import { Box, Button, Flex, Heading, Stack, Text } from '@homebotapp/hb-react-component-catalog'
import { PreferredPartnerCard } from '../../../../../../../shared/HomebotNetwork/PreferredPartnerCard'
import { defineMessages, useIntl } from 'react-intl'
import { useUnverifiedStep } from '../../../../../../../../hooks/homebotNetwork/verificationFlow/useUnverifiedStep'
import { useSelector } from 'react-redux'
import { selectAddress } from '../../../../../../../../store/selectors/home'
import { selectFullName as selectCustomerFullName } from '../../../../../../../../store/selectors/customerProfile'
import { formatStreetAddress } from '../../../../../../../../helpers/formatListingAddress'

const MSG = defineMessages({
  add: {
    id: 'VerificationFlow.UnverifiedOptions.add',
    defaultMessage: 'Yes, add'
  },
  homebotAddedHeading: {
    id: 'ScheduleTour.VerificationFlow.UnverifiedOptions.homebotAddedHeading',
    defaultMessage: 'Homebot added your previous agent from {streetAddress}'
  },
  customerOrClientAddedHeading: {
    id: 'ScheduleTour.VerificationFlow.UnverifiedOptions.customerOrClientAddedHeading',
    defaultMessage: '{addedBy} added a trusted agent to your Homebot'
  },
  requestTour: {
    id: 'ScheduleTour.VerificationFlow.UnverifiedOptions.requestTour',
    defaultMessage: 'Would you like to request the tour with them?'
  },
  keepInLoop: {
    id: 'ScheduleTour.VerificationFlow.UnverifiedOptions.keepInLoop',
    defaultMessage:
      "If so, we'll keep them on your team, and they'll be kept in the loop with real estate related questions."
  },
  remove: {
    id: 'VerificationFlow.UnverifiedOptions.remove',
    defaultMessage: 'No, remove'
  },
  terms: {
    id: 'VerificationFlow.UnverifiedOptions.terms',
    defaultMessage:
      "By clicking 'Yes, Add' you authorize HB Real Estate Services, Inc. and Homebot, Inc. to share your contact information (name and email address) and any other information you include in your question with the agent identified above. You agree that the agent may contact you about your inquiry."
  }
})
/**
 * UnverifiedView specific to the Schedule Tour flow
 *
 * @returns UnverifiedView
 */
export const UnverifiedView = () => {
  const intl = useIntl()
  const { membership, isLoading, onRemove, onVerify } = useUnverifiedStep()
  const streetAddress = useSelector(selectAddress)
  const customerProfileName = useSelector(selectCustomerFullName)

  const addedBy =
    membership.addedBy === 'customer' ? customerProfileName : membership.addedBy === 'homebot' ? 'Homebot' : 'You'

  const heading =
    membership.addedBy === 'homebot'
      ? intl.formatMessage(MSG.homebotAddedHeading, { streetAddress: formatStreetAddress(streetAddress) })
      : intl.formatMessage(MSG.customerOrClientAddedHeading, { addedBy })

  return (
    <Flex direction='column' justifyContent='space-between' data-qa='schedule-tour-unverified-view' h='100%'>
      <Box>
        <Heading textAlign='left'>{heading}</Heading>
        <PreferredPartnerCard partner={membership.customerProfile} corporateProfile={membership.corporateProfile} />
        <Text fontWeight='semibold' color='neutral.900' mt={8}>
          {intl.formatMessage(MSG.requestTour)}
        </Text>
        <Text color='neutral.700'>{intl.formatMessage(MSG.keepInLoop)}</Text>
      </Box>
      <Box>
        <Stack direction='row' gap={2} justifyContent='flex-end'>
          <Button
            variant='ghost'
            colorScheme='danger'
            onClick={onRemove}
            isDisabled={isLoading}
            tracking={{
              guid: 'rs43wCFJPVksqjNzQCJqtj',
              ui_context: 'schedule_tour_verification_flow_unverified_partner_view',
              descriptor: MSG.remove.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.remove)}
          </Button>
          <Button
            isLoading={isLoading}
            onClick={onVerify}
            colorScheme='primary'
            tracking={{
              guid: 'nqVgzGUAEP24H8L2LfzSeP',
              ui_context: 'schedule_tour_verification_flow_unverified_partner_view',
              descriptor: MSG.add.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.add)}
          </Button>
        </Stack>
        <Box bg='neutral.200' borderTop='1px solid' borderColor='neutral.300' mx='-6' mt='6' mb='-6' p='6'>
          <Text size='3xs' color='neutral.600'>
            {intl.formatMessage(MSG.terms)}
          </Text>
        </Box>
      </Box>
    </Flex>
  )
}
